import styled from '@emotion/styled'

const PlayerErrorText = styled.div`
  padding: 10px 0;
  text-align: center;
  width: 100%;
`

const PlayerError = ({ error }) => {
  return <PlayerErrorText>{error}</PlayerErrorText>
}

export default PlayerError
